import React from 'react'
import AccordionSuggestion from 'ui-shared/accordions/AccordionSuggestion'
import ContentToggler from 'ui-shared/ContentToggler'
import Kdivider from 'ui-shared/LayoutComponents/Kdivider'
import BeforeHintArrayInput from './BeforeHintArrayInput'
import DefaultTimeBeforeHint from './DefaultTimeBeforeHint'

type Props = {
  accordionText: string[]
  arrayInputSource?: string
  defaultHintSource?: string
  togglerInputSource?: string
}

const BeforeHintForm: React.FC<Props> = ({
  arrayInputSource = 'timeBeforeHint',
  defaultHintSource = 'defaultTimeBeforeHint',
  togglerInputSource = 'showTimeBeforeHint',
  accordionText,
  ...props
}) => {
  return (
    <React.Fragment>
      <Kdivider title="Time" />
      <ContentToggler
        {...props}
        source={togglerInputSource}
        label="form.fields.showTimeHint"
      >
        <BeforeHintArrayInput source={arrayInputSource} />
        <DefaultTimeBeforeHint source={defaultHintSource} />
      </ContentToggler>
      <AccordionSuggestion
        accordionTitle="form.fields.howItWorks"
        accordionText={accordionText}
      />
    </React.Fragment>
  )
}

export default BeforeHintForm
